'use client'

import Image, { StaticImageData } from "next/image"
import AppIcon from "@/app/components/atomic/AppIcon"

interface ImageToggleProps {
    image: StaticImageData | string
    label: string
    selected?: boolean
    onClick?: () => void
    dataTest?: string
    className?: string
}

export default function ImageToggle({
    image,
    label,
    selected = false,
    onClick,
    dataTest,
    className = "",
}: ImageToggleProps) {
    return (
        <button
            type="button"
            data-test={dataTest}
            aria-pressed={selected}
            onClick={onClick}
            className={`group noselect flex w-full cursor-pointer items-center justify-start sm:justify-center gap-4 rounded-lg border px-6 py-5
                flex-row h-[75px] sm:flex-col sm:gap-6 sm:h-[243px] transition-all duration-300
                ${selected
                    ? 'border-[#B9D3EE] bg-[#F5FAFE]'
                    : 'border-[#eaf1fa] bg-white hover:border-2 hover:border-[#B9D3EE]'}
                ${className}`}
        >
            <div className="relative h-[60px] w-[60px] shrink-0 sm:h-[120px] sm:w-[120px]">
                <Image
                    src={image}
                    alt={label}
                    fill
                    sizes="(min-width: 640px) 120px, 60px"
                    className={`object-contain transition-opacity duration-300 ${
                        selected ? 'opacity-100' : 'opacity-100 sm:opacity-50 group-hover:opacity-100'
                    }`}
                />
            </div>

            <span className={`flex items-center gap-2 text-center text-sm ${selected ? 'text-blue-700' : 'text-[#4a5565]'}`}>
                {selected && <AppIcon type="regular" iconClassName="fa-circle-check" />}
                {label}
            </span>
        </button>
    )
}
